import { useCallback } from 'react'
import { emporionToast as toast } from '@admin/toast'

export const useSlidesAuthGuard = ({
  token,
  t,
}: {
  token: string | null
  t: (key: string) => string
}) =>
  useCallback(
    (messageKey: string) => {
      if (token) return true
      toast.error(t(messageKey))
      return false
    },
    [t, token],
  )
